import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import { StatusCard } from "@/atoms";

export default function ReviewCards({ failedLabel, failedNumber, successLabel, successNumber }) {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                alignItems: "center",
                display: "flex",
                p: 3,
            }}
        >
            <StatusCard status={successLabel || t("labels.successful")} updatesNumber={successNumber} isSuccessful />
            <StatusCard status={failedLabel || t("labels.failed")} updatesNumber={failedNumber} />
        </Box>
    );
}

ReviewCards.propTypes = {
    failedLabel: PropTypes.string,
    failedNumber: PropTypes.number,
    successLabel: PropTypes.string,
    successNumber: PropTypes.number,
};
